import { render } from "./TransmutedGrade.vue?vue&type=template&id=799b382b"
import script from "./TransmutedGrade.vue?vue&type=script&lang=js"
export * from "./TransmutedGrade.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__